/**
 * go-top-btn.js
 * Shopify assets/ 폴더에 업로드 후 main-product.liquid 에 추가:
 *   <script src="{{ 'go-top-btn.js' | asset_url }}"></script>
 */

(function () {
  if (document.getElementById('go-top-btn')) return;

  /* ── 스타일 주입
     주의: Shopify Liquid 엔진이 .js 파일도 파싱하므로
     CSS 중괄호가 }} 패턴을 만들지 않도록
     배열 join 방식 대신 단일 문자열로 작성합니다.
  ── */
  var css = '#go-top-btn {';
  css += 'position:fixed;';
  css += 'bottom:65px;';
  css += 'right:15px;';
  css += 'width:44px;';
  css += 'height:44px;';
  css += 'background:#fff;';
  css += 'border:none;';
  css += 'border-radius:50%;';
  css += 'display:flex;';
  css += 'align-items:center;';
  css += 'justify-content:center;';
  css += 'cursor:pointer;';
  css += 'opacity:0;';
  css += 'pointer-events:none;';
  css += 'transition:opacity 0.25s ease;';
  css += 'z-index:9999;';
  css += '}'; /* 여기서 단독 } 하나만 — }} 패턴 없음 */
  css += '#go-top-btn.visible {';
  css += 'opacity:1;';
  css += 'pointer-events:auto;';
  css += '}'; /* 단독 } */

  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  /* ── 버튼 생성 ── */
  var btn = document.createElement('button');
  btn.id = 'go-top-btn';
  btn.setAttribute('aria-label', 'Go to top');
  btn.innerHTML =
    '<svg width="18" height="10" viewBox="0 0 18 10" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M1 9L9 1L17 9" stroke="#111" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';
  (document.body || document.documentElement).appendChild(btn);

  btn.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  /* ── 표시 제어 ── */
  function initGoTop() {
    var trigger =
      document.querySelector('.lumen-buy-buttons') ||
      document.querySelector('.product-form') ||
      document.querySelector('[id^="ProductInfo-"]');

    if (!trigger) return;

    function updateButton() {
      if (window.innerWidth > 767) {
        btn.classList.remove('visible');
        return;
      }
      if (trigger.getBoundingClientRect().bottom <= window.innerHeight) {
        btn.classList.add('visible');
      } else {
        btn.classList.remove('visible');
      }
    }

    window.addEventListener('scroll', updateButton, { passive: true });
    window.addEventListener('resize', updateButton);
    updateButton();
  }

  /* ── 실행 타이밍 보장
     defer 로드 시 DOMContentLoaded가 이미 발화한 상태일 수 있으므로
     readyState 체크 + setTimeout으로 안전하게 처리
  ── */
  function safeInit() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initGoTop);
    } else {
      /* 이미 DOM 준비 완료 — 다음 틱에 실행해서 다른 스크립트와 충돌 방지 */
      setTimeout(initGoTop, 0);
    }
  }

  safeInit();
})();